import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import './LoadingPage.css';

const LoadingPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      <div className={`Loading-secteur ${isMobile ? 'mobile' : 'desktop'}`}>
        <div className="loading-container">
          <div className="loading-text">
            <span>P</span>
            <span>rofessional</span>
            <span>I</span>
            <span>nspectors</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(LoadingPage);
